// Cannot be made point free.
export const promiseAll = (promises) => Promise.all(promises);
// Cannot be made point free.
export const wrapPromise = (x) => Promise.resolve(x);
// deno-lint-ignore no-explicit-any
export const isPromise = (x) => typeof x?.then === "function" && typeof x?.catch === "function" &&
    typeof x?.finally === "function";
export const doInSequence = (head, ...rest) => wrapPromise(head()).then((x) => rest.length ? doInSequence(rest[0], ...rest.slice(1)) : x);
